import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

export const regimenRoutesRedirectGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  
  // Extract the current URL
  const currentUrl = state.url;
  
  // Check if this is a /user/regimen route
  if (currentUrl.includes('/user/regimen')) {
    // Replace /user/regimen with /regimen
    const newPath = currentUrl.replace('/user/regimen', '/regimen').split('?')[0];
    
    // Get all query params from the current route
    const queryParams = { ...route.queryParams };
    
    // Create URL tree with the new path and all existing query params
    return router.createUrlTree([newPath], {
      queryParams: queryParams,
      queryParamsHandling: 'merge'
    });
  }
  
  // Fallback - redirect to base regimen route
  return router.createUrlTree(['/regimen'], {
    queryParams: route.queryParams,
    queryParamsHandling: 'merge'
  });
};